import { AnimatePresence, MotionConfig, motion } from 'framer-motion'
import { type PropsWithChildren } from 'react'
import useMeasure from 'react-use-measure'
import { sprinkles } from '../theme/sprinkles.css'

type ResizablePanelProps = {
  duration?: number
}

export function ResizablePanel({ children, duration = 0.3 }: PropsWithChildren<ResizablePanelProps>) {
  const [ref, { height }] = useMeasure()

  return (
    <MotionConfig transition={{ duration, type: 'spring' }}>
      <motion.div animate={{ height }} className={sprinkles({ position: 'relative', overflow: 'hidden' })}>
        <AnimatePresence mode="wait">
          <div ref={ref}>{children}</div>
        </AnimatePresence>
      </motion.div>
    </MotionConfig>
  )
}
